import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { color } from '../templates/Ui';
const StyledNotice = styled.div `
    position: relative;
    padding: ${props => (props.icon ? '12px 20px 12px 60px' : '12px 20px')};
    margin-bottom: 20px;
    border-radius: 5px;
    background-color: ${props => {
    if (props.type === TYPES.INFO) {
        return color.notice.info.background;
    }
    if (props.type === TYPES.SUCCESS) {
        return color.notice.success.background;
    }
    if (props.type === TYPES.WARNING) {
        return color.notice.warning.background;
    }
    if (props.type === TYPES.ERROR) {
        return color.notice.error.background;
    }
}};
    color: ${props => {
    if (props.type === TYPES.INFO) {
        return color.notice.info.text;
    }
    if (props.type === TYPES.SUCCESS) {
        return color.notice.success.text;
    }
    if (props.type === TYPES.WARNING) {
        return color.notice.warning.text;
    }
    if (props.type === TYPES.ERROR) {
        return color.notice.error.text;
    }
}};
    border-left: ${props => {
    if (props.hasBorder && props.type === TYPES.INFO) {
        return `5px solid ${color.notice.info.artwork}`;
    }
    if (props.hasBorder && props.type === TYPES.SUCCESS) {
        return `5px solid ${color.notice.success.artwork}`;
    }
    if (props.hasBorder && props.type === TYPES.WARNING) {
        return `5px solid ${color.notice.warning.artwork}`;
    }
    if (props.hasBorder && props.type === TYPES.ERROR) {
        return `5px solid ${color.notice.error.artwork}`;
    }
}};

    &:only-child {
        margin-bottom: 0;
    }
`;
const Title = styled.span `
    display: block;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 2px;
`;
const Text = styled.span `
    display: block;
    font-size: 15px;
    font-weight: 400;
    white-space: pre-line;
`;
const IconWrapper = styled.div `
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 15px;
    max-height: 25px;
    fill: ${props => {
    if (props.type === TYPES.INFO) {
        return color.notice.info.artwork;
    }
    if (props.type === TYPES.SUCCESS) {
        return color.notice.success.artwork;
    }
    if (props.type === TYPES.WARNING) {
        return color.notice.warning.artwork;
    }
    if (props.type === TYPES.ERROR) {
        return color.notice.error.artwork;
    }
}};
`;
export const TYPES = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
};
function Notice({ type, hasBorder, text, title, icon, children }) {
    return (_jsxs(StyledNotice, { type: type, hasBorder: hasBorder, icon: icon, children: [icon && _jsx(IconWrapper, { type: type, children: icon }), _jsx(Title, { children: title }), _jsx(Text, { children: text || children })] }));
}
Notice.Type = TYPES;
export default Notice;
